import * as React from 'react';

import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { Link } from 'react-router-dom';
export interface Section2Props extends BaseComponentProps { lang: string; }
export interface Section2State extends BaseComponentState {
    sosmed: any;
}
import { RecentBlog } from '../core/RecentBlog';
export class Section2 extends BaseComponent<Section2Props, Section2State> {

    constructor(props: Section2Props) {
        super(props);
        this.state = {
            sosmed: (
                <div className="col-md-3 padding-bottom-25">
                    <div id="fb-root" />
                    <div
                        className="fb-page"
                        data-href="https://www.facebook.com/balivillasandmore/"
                        data-tabs="timeline"
                        data-height="150"
                        data-small-header="false"
                        data-adapt-container-width="true"
                        data-hide-cover="false"
                        data-show-facepile="true"
                    >
                        <blockquote
                            cite="https://www.facebook.com/balivillasandmore/"
                            className="fb-xfbml-parse-ignore"
                        >
                            <a href="https://www.facebook.com/balivillasandmore/">Bali Hotels And More</a>
                        </blockquote>
                    </div>
                    <div id="TA_rated823" className="TA_rated"><ul id="aM16zFbvYeV" className="TA_links GDZd9N3RxQ3R"><li id="MSxCWH" className="Ti4EShLBcv"><a target="_blank" href="https://www.tripadvisor.com/"><img src="https://www.tripadvisor.com/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor" /></a></li></ul></div>
                </div>
            )
        };
    }

    componentDidMount() {
        setTimeout(
            () => {
                this.setStateHelper(
                    st => {
                        st.sosmed = (
                            <div className="col-md-3 padding-bottom-25">
                                <div id="fb-root" />
                                <div
                                    className="fb-page"
                                    data-href="https://www.facebook.com/balivillasandmore/"
                                    data-tabs="timeline"
                                    data-height="150"
                                    data-small-header="false"
                                    data-adapt-container-width="true"
                                    data-hide-cover="false"
                                    data-show-facepile="true"
                                >
                                    <blockquote
                                        cite="https://www.facebook.com/balivillasandmore/"
                                        className="fb-xfbml-parse-ignore"
                                    >
                                        <a href="https://www.facebook.com/balivillasandmore/">Bali Hotels And More</a>
                                    </blockquote>
                                </div>
                                <div id="TA_rated823" className="TA_rated"><ul id="aM16zFbvYeV" className="TA_links GDZd9N3RxQ3R"><li id="MSxCWH" className="Ti4EShLBcv"><a target="_blank" href="https://www.tripadvisor.com/"><img src="https://www.tripadvisor.com/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor" /></a></li></ul></div>
                            </div>
                        );
                    }
                );
            },
            5000);
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <div id="bhamFooter" className="container">
                <div className="row">
                    <div className="col-md-3 padding-bottom-25">
                        <a className="logo" href="index.html"> <img alt="Clip-Two" src="/assets/images/logo-with-white.png" /> </a>
                        <p className="padding-top-20">
                            Bali Hotels and More offers you a choice from over 1600 hotels in Bali.
                            Enjoy the convenience of secure on line booking and payment with unbeatable customer service from the Bali travel experts.
                            <br />
                            E. <a href="mailto:info@balihotelsandmore.com">info@balihotelsandmore.com</a><br />
                            P. <a href="cal:1300 582 556">1300 582 556</a><br />
                            WA. <a href="https://wa.me/+6287860006919">+62 878 6000 6919</a>
                        </p>
                        <div className="social-icons">
                            <ul>
                                <li className="social-instagram tooltips" data-original-title="instagram" data-placement="bottom">
                                    <a target="_blank" href="https://www.instagram.com/balihotelsandmore/"> Instagram </a>
                                </li>
                                <li className="social-facebook tooltips" data-original-title="Facebook" data-placement="bottom">
                                    <a target="_blank" href="https://www.facebook.com/balihotelsandmore/" data-original-title="Facebook"> Facebook </a>
                                </li>
                                <li className="social-google tooltips" data-original-title="LinkedIn" data-placement="bottom">
                                    <a target="_blank" href="https://plus.google.com/u/0/118003393109007884268" data-original-title="Google"> Google + </a>
                                </li>
                                <li className="social-youtube tooltips" data-original-title="youtube" data-placement="bottom">
                                    <a target="_blank" href="https://www.youtube.com/channel/UCvgh4XxtRm3yf7K3jGe_OwA?view_as=subscriber" data-original-title="Youtube"> Youtube </a>
                                </li>
                                <li data-placement="bottom" data-original-title="TripAdvisor" className="social-tripadvisor tooltips">
                                    <a href="https://www.tripadvisor.com/Attraction_Review-g303952-d13993230-Reviews-Bali_Tours_And_More-Kintamani_Bangli_Bali.html" target="_blank"> TripAdvisor </a>
                                </li>
                            </ul>

                        </div>
                    </div>
                    <div className="col-md-3 padding-bottom-25">
                        <div className="contact-details">
                            <h4 className="margin-bottom-25">Let Us Help You</h4>
                            <ul className="posts">
                                <li>
                                    <Link to="/request-cancelation"> Cancelation Request</Link>
                                </li>
                                <li>
                                    <Link to="/privacy-policy"> Privacy policy</Link>
                                </li>
                                <li>
                                    <Link to="/terms-of-use"> Terms of Use</Link>
                                </li>
                                <li>
                                    <a href="http://www.baliholidaysandmorevip.com/" target="_blank"> Amazing Offers! for VIP</a>
                                </li>
                                <li>
                                    <a href="https://flight.balihotelsandmore.com/" target="_blank"> Need Flight to Bali?</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3 padding-bottom-25">
                        <div className="contact-details">
                            <RecentBlog lang={this.props.lang} imgWidth={50} count={4} panelColor={''} />
                        </div>
                    </div>
                    <div className="col-md-3 padding-bottom-25">
                        <div id="fb-root" />
                        <div
                            className="fb-page"
                            data-href="https://www.facebook.com/balivillasandmore/"
                            data-tabs="timeline"
                            data-height="150"
                            data-small-header="false"
                            data-adapt-container-width="true"
                            data-hide-cover="false"
                            data-show-facepile="true"
                        >
                            <blockquote
                                cite="https://www.facebook.com/balivillasandmore/"
                                className="fb-xfbml-parse-ignore"
                            >
                                <a href="https://www.facebook.com/balivillasandmore/">Bali Hotels And More</a>
                            </blockquote>
                        </div>
                        <div id="TA_rated823" className="TA_rated"><ul id="aM16zFbvYeV" className="TA_links GDZd9N3RxQ3R"><li id="MSxCWH" className="Ti4EShLBcv"><a target="_blank" href="https://www.tripadvisor.com/"><img src="https://www.tripadvisor.com/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor" /></a></li></ul></div>
                    </div>
                </div>
            </div>
        );
    }
} 


// WEBPACK FOOTER //
// ./src/footer/Section2.tsx